import { createAction, createReducer } from '@reduxjs/toolkit';
import { IUserProfile } from './interface';

const INITIAL_STATE: IUserProfile = {
  cpfCnpj: '',
  createdAt: '',
  email: '',
  id: undefined,
  partnerId: undefined,
  nivel: undefined,
  nomeRazaoSocial: '',
  status: undefined,
  updatedAt: '',
};

export const getUserAction = createAction<Object>(
  '@productsPage/GET_PROFILE_USER'
);

const profileDataReducer = createReducer(INITIAL_STATE, {
  [getUserAction.type]: (state, action) => ({
    ...state,
    cpfCnpj: action.payload.cpf_cnpj,
    createdAt: action.payload.created_at,
    email: action.payload.email,
    id: action.payload.id,
    partnerId: action.payload.id_parceiro,
    nivel: action.payload.nivel,
    nomeRazaoSocial: action.payload.nome_razaosocial,
    status: action.payload.status,
    updatedAt: action.payload.updated_at,
  }),
});

export default profileDataReducer;
